import type { Product } from '@/types/shopify'

export const productUrl = (handle: string, category?: string) => {
  const url = new URL(window.location.href)
  if (category === 'Coffee') {
    url.pathname = '/products/iced-protein-coffee'
    url.hash = `#${handle}`
  } else {
    url.pathname = `/products/${handle}`
  }
  return url.toString()
}

export type ContentData = {
  id: string
  item_price: number
  quantity: number
  variantId: string
  sku: string
  title: string
  category: string
  url: string
  brand: string
  image: string
}

export const toContent = (product: Product, quantity: number, priceCents?: number): ContentData => {
  const {
    sku,
    key,
    handle,
    title,
    type: category,
    flavorForwardImage,
    featured_image
  } = product
  const [ id, variantId ] = String(key || '/').split('/')
  return {
    id,
    item_price: priceCents ? priceCents / 100 : 0,
    quantity,
    variantId,
    sku,
    title,
    category,
    url: productUrl(handle, category),
    brand: 'Oats Overnight',
    image: flavorForwardImage?.url || featured_image
  }
}
